export * from './candidate/candidate.component';
export * from './posts/posts.component';
export * from './company/company.component';
export * from './pladash/pladash.component';
export * from './insjobpost/insjobpost.component';
export * from './notifications/notifications.component';